// extracted by mini-css-extract-plugin
module.exports = {"container":"not-found-view_container__gZXh5","imageContainer":"not-found-view_imageContainer__R0xZ0"};